import { useEffect, useState } from 'react';
import { Brain, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, formatApiError } from '@/lib/api';

const LABELS = { ruolo: 'Ruolo', regione: 'Regione', comune: 'Comune', colture: 'Colture', ettari: 'Ettari', obiettivi: 'Obiettivi' };

export function GiulioMemory({ refreshKey }) {
  const [profile, setProfile] = useState({});
  useEffect(() => { api.get('/ai/profile').then(r => setProfile(r.data || {})).catch(() => {}); }, [refreshKey]);

  const forget = async () => {
    try { await api.delete('/ai/profile'); setProfile({}); toast.success('Giulio ha dimenticato il tuo profilo'); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const entries = Object.entries(profile).filter(([, v]) => v && (!Array.isArray(v) || v.length));
  if (!entries.length) return null;
  return (
    <div className="mt-4 rounded-xl border border-chartreuse/30 bg-chartreuse/5 p-3 text-xs" data-testid="giulio-memory">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1.5 font-bold text-green-700 dark:text-chartreuse"><Brain size={13}/> Cosa ricorda Giulio</div>
        <button onClick={forget} aria-label="Dimentica" data-testid="giulio-memory-forget"
          className="text-muted-foreground hover:text-destructive transition-colors"><Trash2 size={13}/></button>
      </div>
      <ul className="space-y-0.5 text-muted-foreground">
        {entries.map(([k, v]) => <li key={k}><span className="text-foreground">{LABELS[k] || k}:</span> {Array.isArray(v) ? v.join(', ') : String(v)}</li>)}
      </ul>
    </div>
  );
}
